import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import "leaflet/dist/leaflet.css";
import { Icon, divIcon, point } from "leaflet";
import "./Style/map.css";

export const HEAD_OFFICE_GOOGLE_MAPS_URL =
  "https://maps.app.goo.gl/jMpwCd2GTBNxFgxZ7?g_st=iw";

const HEAD_OFFICE_MARKER = {
  id: 1,
  geocode: [51.9867332, -0.9802097],
  popUp: "UK TO MARS LTD — Head Office",
  googleMapsUrl: HEAD_OFFICE_GOOGLE_MAPS_URL,
};

const ALL_MARKERS = [
  HEAD_OFFICE_MARKER,
  {
    id: 2,
    geocode: [52.4267294, -1.500503],
    popUp: "Coventry",
  },
];

const MapUK = ({ officeOnly = false, embedded = false }) => {
  const markers = officeOnly ? [HEAD_OFFICE_MARKER] : ALL_MARKERS;
  const center = officeOnly
    ? HEAD_OFFICE_MARKER.geocode
    : [51.9878217, -0.981914];
  const zoom = officeOnly ? 15 : 8;
  const mapStyle = embedded
    ? { height: "100%", width: "100%", minHeight: 340 }
    : undefined;

  const customIcon = new Icon({
    iconUrl: require("./Image/marker-icon.png"),
    iconSize: [38, 38],
  });

  const createCustomClusterIcon = (cluster) => {
    return new divIcon({
      html: `<div class ="cluster-icon">${cluster.getChildCount()}</div>`,
      className: "custom-marker-cluster",
      iconSize: point(33, 33, true),
    });
  };
  const handleMarkerClick = (marker) => {
    const googleMapsUrl =
      marker.googleMapsUrl ??
      `https://www.google.com/maps?q=${marker.geocode[0]},${marker.geocode[1]}`;
    window.open(googleMapsUrl, "_blank", "noopener,noreferrer");
  };

  // Function to handle marker hover (show popup on mouse over)
  const handleMarkerHover = (e) => {
    e.target.openPopup(); // Opens the popup when mouse is over the marker
  };

  // Function to handle mouse out event (close popup when mouse leaves the marker)
  const handleMarkerMouseOut = (e) => {
    e.target.closePopup(); // Closes the popup when mouse leaves the marker
  };
  return (
    <div style={embedded ? { height: "100%", width: "100%" } : undefined}>
      <MapContainer center={center} zoom={zoom} style={mapStyle}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MarkerClusterGroup
          chunkedLoading
          iconCreateFunction={createCustomClusterIcon}
        >
          {markers.map((marker) => (
            <Marker
              key={marker.id}
              position={marker.geocode}
              icon={customIcon}
              eventHandlers={{
                click: () => handleMarkerClick(marker),
                mouseover: handleMarkerHover,
                mouseout: handleMarkerMouseOut,
              }}
            >
              <Popup>
                <strong>{marker.popUp}</strong>
                {marker.googleMapsUrl ? (
                  <>
                    <br />
                    <a
                      href={marker.googleMapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open in Google Maps
                    </a>
                  </>
                ) : null}
              </Popup>
            </Marker>
          ))}
        </MarkerClusterGroup>
      </MapContainer>
    </div>
  );
};

export default MapUK;
